import { Icon, Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	onClick: any;
}

export const AllFilters = ({ onClick }: Props) => {
	return (
		<div className={styles.wrapper} onClick={onClick}>
			<Text variant="inter/15/semi" color="grey">
				All filters
			</Text>
			<Icon icon="chevrons-down" size={20} />
		</div>
	);
};
